import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";

export default function VideoCard({ video }: { video: VideoItem }) {
  return (
    <article className="group card-surface overflow-hidden transition-colors hover:border-primary-300">
      <Link to={`/video/${video.id}`} className="block" aria-label={`播放：${video.title}`}>
        <div className="relative aspect-video overflow-hidden">
          <img
            src={video.cover}
            alt={video.title}
            title={`${video.title} - 瓜趣视频在线观看`}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <span className="absolute bottom-2 right-2 rounded bg-black/60 px-1.5 py-0.5 text-xs text-white">
            {video.duration}
          </span>
          {video.hot && (
            <span className="absolute left-2 top-2 flex items-center gap-1 rounded bg-primary-500 px-1.5 py-0.5 text-xs font-medium text-background-50">
              <i className="ri-fire-fill text-xs" aria-hidden="true"></i>
              热门
            </span>
          )}
        </div>
        <div className="p-3.5">
          <span className="text-xs font-medium text-primary-600">{video.category}</span>
          <h3 className="mt-1 line-clamp-2 text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
            {video.title}
          </h3>
          <div className="mt-2.5 flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" aria-hidden="true"></i>
              {video.views}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-heart-line" aria-hidden="true"></i>
              {video.likes}
            </span>
            <span className="ml-auto flex items-center gap-1 text-foreground-400">
              <i className="ri-play-circle-line" aria-hidden="true"></i>
              播放
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}